import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import axios from 'axios';
import { clearAuthSession } from './utils/authSession';

// Axios interceptor
axios.interceptors.request.use(
  (config) => {
    store.commit('setIsLoading', true);
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  (error) => {
    store.commit('setIsLoading', false);
    return Promise.reject(error);
  }
);


axios.interceptors.response.use(
  (response) => {
    store.commit('setIsLoading', false);
    return response;
  }, (error) => {
    store.commit('setIsLoading', false);
    if (error.response && error.response.status === 401 && !error.config?.skipAuthRedirect) {
      clearAuthSession();
      store.commit('setLoggedIn', false);
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);


// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    //
  },
})

const app = createApp(App);

function formatDateTime(value, options) {
  if (!value) return '';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const parts = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
    ...options,
  }).formatToParts(date);

  const getPart = (type) => parts.find(part => part.type === type)?.value || '';

  return `${getPart('day')}/${getPart('month')}/${getPart('year')}, ${getPart('hour')}:${getPart('minute')}:${getPart('second')}`;
}

app.config.globalProperties.$filters = {
  toLocalTime(value) {
    if (!value) return '';
    const date = new Date(value);
    return date.toLocaleString();
  },
  toMexicoCityTime(value) {
    return formatDateTime(value, { timeZone: 'America/Mexico_City' });
  }
};

app.use(store).use(router).use(vuetify).mount('#app')
